var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"br_section"},[_c('h2',{staticClass:"br"},[_vm._v("BisonRouter GUI")])]),_c('p',[_vm._v(" Version: a0.25.0 ")])])}]

export { render, staticRenderFns }